import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { BrokerMappingService } from '../broker-mapping.service';
import { BrokerMapping } from '../broker-mapping.model';
import { map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-edit-broker-mapping',
    templateUrl: './edit-broker-mapping.component.html',
    styleUrls: ['./edit-broker-mapping.component.scss'],
    imports: [CommonModule, TableModule, ButtonModule, FormsModule, Select,
        MatProgressSpinnerModule, MatTooltipModule, ConfirmDialogModule, DrawerModule, ToastModule
    ]
})
export class EditBrokerMappingComponent implements OnInit {
  @Input('columns') columns: any;
  editRow!: BrokerMapping;
  constructor(public brokerMappingService: BrokerMappingService,
    private userService: UserService,
    private messageService: MessageService,) { }

  ngOnInit() {
    this.editRow = new BrokerMapping();
  }

  onSave() {
    this.brokerMappingService.isLoadingResults = true;
    this.editRow = this.brokerMappingService.editRow;
    let payload = {
      "mpid": this.userService.getActiveMPID(),
      "receivedFromMPID": this.editRow['ReceivedFromMPID'],
      "customerID": this.editRow['CustomerID'],
      "affiliateFlag": this.editRow['AffiliateFlag'],
      "id": this.editRow['id'],
      "user": this.userService.getUserName(),
    }
    this.brokerMappingService.getEdit(payload)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (data:any) => {
          this.brokerMappingService.isLoadingResults = false;
          this.brokerMappingService.isEdit = false;
          this.brokerMappingService.reloadData();
          if(data.status){
          this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: data.data });
          }else{
          this.messageService.add({ severity: 'error', summary: 'Update Success Message', detail: data.data });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.brokerMappingService.isLoadingResults = false;
          this.brokerMappingService.isEdit = false;
        }
      });  
  }

  onClose() {
    this.brokerMappingService.isEdit = false;
  }

  onReset() {

  }

  ngOnDestroy() {
    this.brokerMappingService.isEdit = false;
  }
}